<template>
  <main class="air-service" v-bind="dKey('pageid', pageName, postId)">
    <div class="fixed-video"><img src="/static-assets/vid/img/air/large/0001.jpg" alt="" /></div>
    <section class="in1">
      <div class="container">
        <div class="hb1">
          <div class="hb-linr"></div>
          <div v-bind="dKey('title')" class="text-hb">{{info.title}}</div>
        </div>
        <div class="title-fs">
          <h1 v-bind="dKey('weTitle')" class="text-center" v-html="info.weTitle"></h1>
          <h2 class="text-center"><span v-bind="dKey('weSubtitle')">{{info.weSubtitle}}</span><div v-bind="dKey('weSubtitle2')">{{info.weSubtitle2}}</div></h2>
        </div>
      </div>
    </section>

    <section class="in2">
      <div class="container has-paralax">
        <div id="id-0" data-pos="5" data-speed="1.2" class="paralax left">
          <div class="braund">
            <div class="bra-top">
              <svg style="margin-top: 9px" width="70" height="52" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 70 52">
                <defs>
                  <path d="M554.99989,221.66974c0,3.39338 -7.05547,7.87897 -16.30028,12.16739c0.0999,0.14089 0.17586,0.30204 0.22042,0.47928l4.37508,17.332c0.16628,0.6556 -0.15163,1.33736 -0.76138,1.64069l-5.8334,2.88864c-0.21584,0.10679 -0.43751,0.15594 -0.65918,0.15594c-0.42595,0 -0.84595,-0.18482 -1.12873,-0.53142l-12.62972,-15.28783c-11.48153,4.15252 -22.34659,7.15328 -25.617,7.15328c-7.93041,0 -11.66679,-0.28595 -11.66679,-2.88864c0,-0.56324 0,-1.98735 5.18887,-4.85594l-4.94385,-7.34294c-0.38498,-0.57191 -0.3091,-1.33452 0.18379,-1.82268l2.91664,-2.88858c0.44323,-0.44201 1.12003,-0.5488 1.68285,-0.27151l11.01357,5.45672l5.85563,-2.89973l-15.32905,-8.6752c-0.39368,-0.22248 -0.66204,-0.61528 -0.72338,-1.06307c-0.06123,-0.44779 0.09327,-0.8954 0.41416,-1.21323l5.83351,-5.77739c0.38212,-0.37559 0.93624,-0.51426 1.44962,-0.36109l24.98787,7.42429c0.07209,-0.05049 0.14982,-0.09522 0.23285,-0.13322c0.39963,-0.17916 9.86732,-4.46297 18.11279,-4.46297c11.84761,0 13.12511,4.03834 13.12511,5.77722zM501.69113,235.9601c-0.41119,0.20215 -0.89539,0.20215 -1.30371,0l-10.72483,-5.31228l-1.32717,1.31442l5.1685,7.68088c0.23048,0.34082 0.30338,0.76545 0.19833,1.16408c-0.10494,0.39864 -0.37331,0.73079 -0.74375,0.92145c-1.71215,0.87524 -3.42716,1.93537 -4.38377,2.68066c2.05925,0.36976 6.45184,0.36976 8.09097,0.36976c9.75929,0 55.41744,-17.72191 55.41744,-23.10933c0,-0.43189 -0.41356,-0.9612 -1.34998,-1.4482c-0.03581,0.00261 -0.07198,0.00394 -0.10846,0.00394c-5.04295,0 -7.63012,2.38315 -7.73792,2.48428c-0.2829,0.26585 -0.64751,0.39864 -1.00914,0.39864c-0.38212,0 -0.76424,-0.14728 -1.04713,-0.43912c-0.55698,-0.57191 -0.54829,-1.4762 0.02335,-2.03367c0.0734,-0.06972 1.02591,-0.97348 2.82301,-1.81738c-0.56758,-0.02425 -1.16791,-0.03713 -1.80219,-0.03713c-4.97161,0 -10.62873,1.77972 -13.97188,3.02226c0.45253,0.20724 0.77115,0.63148 0.83521,1.13159c0.06992,0.5663 -0.2013,1.12377 -0.69706,1.41838l-14.58355,8.66597c-0.2306,0.13584 -0.49004,0.20515 -0.7497,0.20515c-0.24799,0 -0.49873,-0.06348 -0.72338,-0.19065l-2.04576,-1.15776zM523.70647,223.5589l-25.16533,-7.47873l-3.87051,3.83036l18.01655,10.19704zM536.43505,253.07828l3.74508,-1.85456l-4.08885,-16.20681c-3.48738,1.53953 -7.20414,3.03743 -10.91753,4.43201zM519.99962,263.55544c0,0.79727 -0.65346,1.44438 -1.45844,1.44438h-32.08385c-0.80498,0 -1.45844,-0.6471 -1.45844,-1.44438c0,-0.79727 0.65346,-1.44438 1.45844,-1.44438h32.08374c0.80498,0 1.45832,0.6471 1.45855,1.44438z" id="Path-0" />
                </defs>
                <desc>Generated with Avocode.</desc>
                <g transform="matrix(1,0,0,1,-485,-213)">
                  <g>
                    <title>Forma 1</title>
                    <use xlink:href="#Path-0" fill="#ffffff" fill-opacity="1" />
                  </g>
                </g>
              </svg>
            </div>
            <div class="bra-content"><span v-bind="dKey('weList#0')">{{getData('weList', 0)}}</span></div>
          </div>
        </div>
        <div id="id-1" data-pos="7" data-speed="1.2" class="paralax right">
          <div class="braund">
            <div class="bra-top">
              <svg id="SVGDoc" width="66" height="66" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 66 66">
                <defs>
                  <path d="M1307.60056,372.91587v11.75751l5.62705,3.04587c0.3954,-1.37853 1.66836,-2.39052 3.173,-2.39052c1.8195,0 3.30013,1.47948 3.2999,3.29781v2.59645l3.46313,1.87456c0.43216,-1.31853 1.6753,-2.27376 3.13713,-2.27376c1.8195,0 3.30013,1.47965 3.2999,3.29781v2.46027l3.82381,2.0698c0.35419,0.19235 0.57529,0.56285 0.57529,0.96635v6.59544c0,0.36058 -0.17704,0.69795 -0.47401,0.90356c-0.18482,0.12967 -0.40363,0.19569 -0.62473,0.19569c-0.13,0 -0.26081,-0.0231 -0.38727,-0.06925l-24.91322,-9.33595v9.40634c0,0.06936 -0.00652,0.13964 -0.02083,0.20781l-1.10911,5.74707l10.49544,6.29281c0.33119,0.19903 0.53352,0.55628 0.53364,0.94195v4.39706c0,0.32316 -0.14191,0.62983 -0.38944,0.83866c-0.19901,0.16925 -0.45101,0.26053 -0.70953,0.26053c-0.06042,0 -0.11982,-0.00538 -0.18024,-0.01535l-11.9501,-1.99023c-0.59894,1.18461 -1.8548,2.00586 -3.26769,2.00586c-0.00217,0 -0.00435,0 -0.00549,0c-1.40099,0 -2.64912,-0.80879 -3.25789,-2.00628l-11.95966,1.99184c-0.05951,0.00878 -0.11993,0.01433 -0.17933,0.01433c-0.25852,0 -0.51041,-0.09128 -0.71068,-0.26053c-0.24639,-0.2077 -0.38944,-0.51557 -0.38944,-0.83872v-4.397c0,-0.38703 0.20245,-0.74421 0.53352,-0.94212l10.4964,-6.29339l-1.10984,-5.7466c-0.01339,-0.06936 -0.01991,-0.13862 -0.01991,-0.20781v-9.40673l-24.91413,9.33635c-0.12543,0.04717 -0.25635,0.0692 -0.38612,0.0692c-0.2211,0 -0.44003,-0.06704 -0.62702,-0.19569c-0.29709,-0.20662 -0.4731,-0.54297 -0.4731,-0.9035v-6.5955c0,-0.40334 0.2211,-0.77383 0.57644,-0.96618l3.82347,-2.06964v-2.46043c0,-1.81815 1.48075,-3.29781 3.30013,-3.29781c1.46183,0 2.70505,0.95523 3.13712,2.27376l3.46292,-1.87447v-2.59654c0,-1.81815 1.48075,-3.29781 3.30013,-3.29781c1.50465,0 2.7777,1.0119 3.17292,2.3905l5.62724,-3.04602v-11.75513c-0.01968,-3.5649 0.81184,-7.14294 2.40349,-10.33854c0.97469,-1.96215 3.21648,-2.9866 5.34393,-2.43151c1.4542,0.45186 2.58934,1.47965 3.16578,2.83281c1.48064,3.04283 2.27932,6.49561 2.28699,9.93504zM1305.40054,407.2071c0,0 0,-10.88689 0,-10.88689v-23.40213c-0.00778,-3.10868 -0.72933,-6.2305 -2.08889,-9.02814c-0.34435,-0.80786 -0.98236,-1.38384 -1.76891,-1.62903c-1.06476,-0.2782 -2.25277,0.26155 -2.76752,1.2971c-1.44001,2.89107 -2.1912,6.1262 -2.17369,9.35469v34.29542l2.95017,15.28627c0.10677,0.76947 0.72498,1.307 1.44768,1.307c0.72384,0 1.34319,-0.53754 1.44207,-1.25095zM1270.2,400.2731v4.35413l24.20036,-9.06891v-8.38387zM1331.80092,400.27299l-24.20036,-13.09977v8.38515l24.20036,9.06887zM1286.7001,388.62654c0,-0.60565 -0.49393,-1.09925 -1.10001,-1.09925c-0.60608,0 -1.10001,0.49348 -1.10001,1.09925v1.40568l2.20001,-1.19086zM1276.79993,394.1216c0,-0.60571 -0.49393,-1.09817 -1.10001,-1.09817c-0.60608,0 -1.10001,0.49258 -1.10001,1.09817l0,1.26957l2.34541,-1.26957zM1317.5005,388.62654c0,-0.60565 -0.49278,-1.09925 -1.10001,-1.09925c-0.60722,0 -1.10001,0.49348 -1.10001,1.09925l0,0.21475l2.20001,1.19085zM1327.40067,394.1216c0,-0.60571 -0.49278,-1.09817 -1.10001,-1.09817c-0.60722,0 -1.10001,0.49258 -1.10001,1.09817l-0.14515,0l2.34517,1.26942zM1286.69918,421.12691v2.47664l10.48958,-1.74723l-1.21486,-6.29037zM1315.30083,423.60236v-2.47545l-9.27368,-5.56028l-1.21371,6.2891zM1304.24332,370.69087l-2.08786,0.6915l-0.74799,-2.25348c-0.05836,-0.17259 -0.22121,-0.2902 -0.40604,-0.2902c-0.1815,0.00119 -0.34424,0.12542 -0.39825,0.30787l-0.76218,2.2447l-2.08351,-0.70798l0.7481,-2.19844c0.31242,-1.07394 1.31561,-1.83361 2.48268,-1.8446c1.11992,0.02746 2.14622,0.71896 2.50591,1.79511z" id="Path-3" />
                </defs>
                <desc>Generated with Avocode.</desc>
                <g transform="matrix(1,0,0,1,-1268,-360)">
                  <g>
                    <title>Forma 1</title>
                    <use xlink:href="#Path-3" fill="#ffffff" fill-opacity="1" />
                  </g>
                </g>
              </svg>
            </div>
            <div class="bra-content"><span v-bind="dKey('weList#1')">{{getData('weList', 1)}}</span></div>
          </div>
        </div>
        <div id="id-2" data-pos="9" data-speed="1.2" class="paralax left">
          <div class="braund">
              <div class="bra-top">
                <img src="data:image/png;base64,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" alt="">
              </div>
              <div class="bra-content"><span v-bind="dKey('weList#2')">{{getData('weList', 2)}}</span></div>
            </div>
          </div>
        </div>
    </section>

    <section class="geography-title">
      <div class="container">
        <div class="title-fs">
          <h1 v-bind="dKey('geoTitle')" class="text-center">{{info.geoTitle}}</h1>
        </div>
      </div>
    </section>

    <section class="geography-content">
      <div class="container has-paralax">
        <div id="id-9" data-pos="41" data-speed="1.5" class="paralax left">
          <div class="c-block ma1">
            <div class="content-va"><span v-bind="dKey('geoList#0#strong')">{{getData('geoList', 0, 'strong')}}</span>&nbsp;<i v-bind="dKey('geoList#0#text')">{{getData('geoList', 0, 'text')}}</i></div>
          </div>
        </div>
        <div id="id-10" data-pos="44" data-speed="1.5" class="paralax right">
          <div class="c-block ma2">
            <div class="content-va"><span v-bind="dKey('geoList#1#strong')">{{getData('geoList', 1, 'strong')}}</span>&nbsp;<i v-bind="dKey('geoList#1#text')">{{getData('geoList', 1, 'text')}}</i></div>
          </div>
        </div>
        <div id="id-11" data-pos="47" data-speed="1.5" class="paralax left">
          <div class="c-block ma3">
            <div class="content-va"><span v-bind="dKey('geoList#2#strong')">{{getData('geoList', 2, 'strong')}}</span>&nbsp;<i v-bind="dKey('geoList#2#text')">{{getData('geoList', 2, 'text')}}</i></div>
          </div>
        </div>
        <div id="id-12" data-pos="50" data-speed="1.5" class="paralax right">
          <div class="c-block ma4">
            <div class="content-va"><span v-bind="dKey('geoList#3#strong')">{{getData('geoList', 3, 'strong')}}</span>&nbsp;<i v-bind="dKey('geoList#3#text')">{{getData('geoList', 3, 'text')}}</i></div>
          </div>
        </div>
        <div id="id-13" data-pos="53" data-speed="1.5" class="paralax left">
          <div class="c-block ma5">
            <div class="content-va"><span v-bind="dKey('geoList#4#strong')">{{getData('geoList', 4, 'strong')}}</span>&nbsp;<i v-bind="dKey('geoList#4#text')">{{getData('geoList', 4, 'text')}}</i></div>
          </div>
        </div>
        <div id="id-14" data-pos="56" data-speed="1.5" class="paralax right">
          <div class="c-block ma6">
            <div class="content-va"><span v-bind="dKey('geoList#5#strong')">{{getData('geoList', 5, 'strong')}}</span>&nbsp;<i v-bind="dKey('geoList#5#text')">{{getData('geoList', 5, 'text')}}</i></div>
          </div>
        </div>
        <div id="id-15" data-pos="59" data-speed="1.5" class="paralax left">
          <div class="c-block ma7">
            <div class="content-va"><span v-bind="dKey('geoList#6#strong')">{{getData('geoList', 6, 'strong')}}</span>&nbsp;<i v-bind="dKey('geoList#6#text')">{{getData('geoList', 6, 'text')}}</i></div>
          </div>
        </div>
      </div>
    </section>

    <section class="flytry-title">
      <div class="container">
        <div class="title-fs">
          <h1 v-bind="dKey('capTitle')" class="text-center">{{info.capTitle}}</h1>
        </div>
      </div>
    </section>

    <section class="flytry-element">
      <div class="container has-paralax">
        <div id="id-16" data-pos="69" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">1</div>
            <div v-bind="dKey('capList#0')" class="clip-text align-middle">{{getData('capList', 0)}}</div>
          </div>
        </div>
        <div id="id-17" data-pos="71" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">2</div>
            <div v-bind="dKey('capList#1')" class="clip-text align-middle">{{getData('capList', 1)}}</div>
          </div>
        </div>
        <div id="id-18" data-pos="73" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">3</div>
            <div v-bind="dKey('capList#2')" class="clip-text align-middle">{{getData('capList', 2)}}</div>
          </div>
        </div>
        <div id="id-19" data-pos="75" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">4</div>
            <div v-bind="dKey('capList#3')" class="clip-text align-middle">{{getData('capList', 3)}}</div>
          </div>
        </div>
        <div id="id-20" data-pos="78" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">5</div>
            <div v-bind="dKey('capList#4')" class="clip-text align-middle">{{getData('capList', 4)}}</div>
          </div>
        </div>
        <div id="id-21" data-pos="80" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">6</div>
            <div v-bind="dKey('capList#5')" class="clip-text align-middle">{{getData('capList', 5)}}</div>
          </div>
        </div>
        <div id="id-22" data-pos="82" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">7</div>
            <div v-bind="dKey('capList#6')" class="clip-text align-middle">{{getData('capList', 6)}}</div>
          </div>
        </div>
        <div id="id-23" data-pos="84" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">8</div>
            <div v-bind="dKey('capList#7')" class="clip-text align-middle">{{getData('capList', 7)}}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="conter-title">
      <div class="container">
        <div class="title-fs">
          <h1 v-bind="dKey('countTitle')" class="text-center">{{info.countTitle}}</h1>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-4">
            <div class="item-c">
              <div v-bind="dKey('countList#0#title')" class="title-c" v-html="getData('countList', 0, 'title')"></div>
              <div v-bind="dKey('countList#0#counter')" class="number-c">{{getData('countList', 0, 'counter')}}</div>
              <div v-bind="dKey('countList#0#text')" class="description-c" v-html="getData('countList', 0, 'text')"></div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="item-c">
              <div v-bind="dKey('countList#1#title')" class="title-c" v-html="getData('countList', 1, 'title')"></div>
              <div v-bind="dKey('countList#1#counter')" class="number-c">{{getData('countList', 1, 'counter')}}</div>
              <div v-bind="dKey('countList#1#text')" class="description-c" v-html="getData('countList', 1, 'text')"></div>
            </div>
          </div>
          <div class="col-md-12 col-lg-4">
            <div class="item-c">
              <div v-bind="dKey('countList#2#title')" class="title-c" v-html="getData('countList', 2, 'title')"></div>
              <div v-bind="dKey('countList#2#counter')" class="number-c">{{getData('countList', 2, 'counter')}}</div>
              <div v-bind="dKey('countList#2#text')" class="description-c" v-html="getData('countList', 2, 'text')"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <span v-if="$root.isAdmin()" v-bind="dKey('url')" class="hidden">{{url}}</span>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'ServiceAir',

  data() {
    return {
      url: 'air-freight',
      animLoaded: false,
      info: {},
      postId: 0,
      pageName: 'service_page',
      errors: []
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  created() {
    this.$root.$emit('service_page', true)

    this.getPost()
  },

  watch:{
    $route () {
      this.getPost()
    }
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    getData(key, index, field) {
      if (this.info[key] && this.info[key][index])
        return field ? this.info[key][index][field] : this.info[key][index]
      return ''
    },

    getPost() {
      let self = this

      HTTP.get('posts?filter=' + encodeURIComponent(JSON.stringify({
        where: {
          and: [
            {type: 'service_page'},
            {url: this.url},
            {language_id: this.$root.language_id}
          ]
        }
      }))).then(response => {
        if (response.data.length) {
          self.info = response.data[0].json.length ? JSON.parse(response.data[0].json) : {}
          self.info.title = response.data[0].title
          self.info.id =
          self.postId = response.data[0].id
          self.info.url = response.data[0].url

          document.querySelector('title').text = response.data[0].meta_title.length
            ? response.data[0].meta_title
            : 'Antwerk'

          document.querySelector('meta[name="description"]').text = response.data[0].meta_description.length
            ? response.data[0].meta_description
            : ''

          if (!self.animLoaded) {
            setTimeout(function(){
              window.frameFolder = 'air';
              window.frameCount = 512;

              self.$root.scriptLoader('/static-assets/js/img-anim.js?v=5.0', () => {
                self.animLoaded = true
              })
            }, 1000);
          }
        }
      }).catch(e => {
        self.errors.push(e)
      })
    }
  }
}

</script>
